export default {"src":"/_next/static/media/circle-info.7d5881fc.svg","height":16,"width":16};